var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rest-list-action',{attrs:{"icon":"el-icon-document-copy","title":_vm.$t(_vm.title ? _vm.title : 'RestList_Action_Copy'),"route":_vm.route,"data-qa":"copy-action-button"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fc578d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/rest/RestListActionCopy.vue
// module id = null
// module chunks = 